import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import { TooltipInfoDto } from '@/repositories/generated/apiClients';

require('./cellTooltip.css');

export default function headerTooltip(element: HTMLElement, tooltipInfo: TooltipInfoDto) {
  return tippy(element, {
    onShow(instance) {
      instance.setContent(formulateTooltipText(tooltipInfo));
    },
    placement: 'top',
    maxWidth: 500,
    delay: [250, 50],
    allowHTML: true,
    theme: 'input-grid'
  });
}

function formulateTooltipText(tooltipInfo: TooltipInfoDto) {
  const tooltipTexts = [] as [innerText: string, cssClass: string][];

  const displayName = tooltipInfo.displayName.split('*');
  displayName.length > 1 && tooltipTexts.push([`As defined by selected grouping:`, 'tooltip-content-small']);
  tooltipTexts.push([`<strong>${displayName[0]}</strong>`, 'tooltip-content-emphasis']);

  // extra metadata
  tooltipInfo?.cadence && tooltipTexts.push([`${tooltipInfo?.cadence}`, '']);
  tooltipInfo?.unitsOfMeasure && tooltipTexts.push([`Units: ${tooltipInfo?.unitsOfMeasure}`, '']);
  tooltipInfo?.tooltip && tooltipTexts.push([tooltipInfo?.tooltip, '']);

  return tooltipTexts.map(([x, y]) => `<div class="${y}">${x}</div>`).join('\n');
}
